import { Flex, Text } from "@chakra-ui/react";
import { ElementType } from "react";
import { useLightMode } from "src/common/hooks/lightMode";

export const LabelWithOptionalIcon = ({
  label,
  LeftIcon,
}: {
  label: string;
  LeftIcon?: ElementType;
}) => {
  const { lightMode } = useLightMode();

  return (
    <Flex>
      {LeftIcon && (
        <Flex mr="12px" alignItems={"center"}>
          <LeftIcon
            fontSize="22px"
            aria-hidden
            color={lightMode ? "var(--chakra-colors-gray-500)" : "#C7C7C7"}
          />
        </Flex>
      )}
      <Text>{label}</Text>
    </Flex>
  );
};
